export const PRODUCT_RECOMMENDATION_LIST_SUCCESS = 'PRODUCT_RECOMMENDATION_LIST_SUCCESS';
export const CREATE_PRODUCT_RECOMMENDATION_SUCCESS = 'CREATE_PRODUCT_RECOMMENDATION_SUCCESS';
export const EDIT_PRODUCT_RECOMMENDATION_SUCCESS = 'EDIT_PRODUCT_RECOMMENDATION_SUCCESS';
export const REMOVE_PRODUCT_RECOMMENDATION_SUCCESS = 'REMOVE_PRODUCT_RECOMMENDATION_SUCCESS';
